<template>
  <div>
    <a-tooltip placement="top">
      <template #title>Notities</template>
      <a-badge :count="noteCount">
        <a-button @click="showDrawer"
                  class="show-notes-drawer xl-button" :type="noteCount > 0 ? 'primary' : ''"
                  shape="circle"
                  size="large">
          <message-icon style="margin-top: .5rem;"></message-icon>
        </a-button>
      </a-badge>
    </a-tooltip>

    <a-drawer
        placement="right"
        :visible="visible"
        @close="onClose"
        :body-style="{
          'padding': 0,
        }"
        width="60%"
    >
      <h3 style="padding: 1.5rem 0.5rem; margin-bottom: 0">
        <a-badge :count="noteCount">
          <a-button @click="onClose" :type="noteCount > 0 ? 'primary' : ''" class="xl-button" shape="circle"
                    size="large">
            <message-icon></message-icon>
          </a-button>
        </a-badge>
        Notities
      </h3>

      <paginatedCategoryComponent
          :category-id="categoryId"
          :customer-id="customerId"
          :instance="instance"
          :show-filter-options="true"
      />

    </a-drawer>
  </div>
</template>

<script>
import PaginatedCategoryComponent from "./PaginatedCategoryComponent.vue";
import OverviewFilterComponent from "./OverviewFilterComponent.vue";
import AttachableNoteTableRowComponent from "./AttachableRowComponent.vue";
import attachableApi from "~/api/attachable";

export default {
  name: "NotesByCategoryDrawerOverviewComponent",
  components: {
    PaginatedCategoryComponent,
    AttachableNoteTableRowComponent,
    OverviewFilterComponent
  },
  props: {
    categoryId: {
      type: [Number, String],
      default: null,
    },
    customerId: {
      type: [Number, String],
      default: null,
    },
    instance: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      noteCount: 0,
      context: null,
      childClass: 'App\\Models\\Note',
    };
  },
  created() {
    this.setContext();
    this.getNotesCountByContext();
  },
  methods: {
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    setContext() {
      if (this.instance !== null) {
        this.context = 'instance';
      } else {
        this.context = 'family';
      }
    },
    getNotesCountByContext() {
      if (this.context === 'instance') {
        attachableApi.countByInstanceAndChildClass(
            this.instance,
            this.childClass
        ).then((response) => {
          this.noteCount = response.data;
        }).finally(() => {})
      } else {
        attachableApi.countByFamilyCategoryAndChildClass(
            this.customerId,
            this.categoryId,
            this.childClass
        ).then((response) => {
          this.noteCount = response.data;
        }).finally(() => {})
      }
    }
  },
}
</script>

<style scoped>
.xl-button {
  width: 45px;
  height: 45px;
}
</style>